export const useActiveAccount = {
  computed: {
    activeAccount() {
      return this.$store.state.Auth.activeAccount ?? {};
    },
  },
};
